import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

import { QueryParamKeys } from '@inflo/types';

/**
 * Office sign-in / sign-out dialog. The dialog is opened by `Modals.openSignInModal` /
 * `Modals.openSignOutModal` from the parent task pane and navigates straight to the IdP.
 *
 * The parent (`useHomeController.signOut` / `Login.login`) is responsible for emitting
 * `dispatchUserLoggedIn` / `dispatchUserLoggedOut` once the dialog returns; this component
 * deliberately does not broadcast auth-state events to avoid double-fires that would cause
 * `useAuthState` to run extra silent renews / cleanups.
 */
export const Auth = () => {
  const auth = useAuth();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const signOutParam = urlParams.get(QueryParamKeys.Signout);
    const isSignOut = typeof signOutParam === 'string' && signOutParam.toLowerCase() === 'true';
    const loginHint = urlParams.get(QueryParamKeys.LoginHint);

    if (isSignOut) {
      // `revokeTokensOnSignout: true` (in `Auth.userManager`) makes this revoke the refresh
      // token before redirecting to the IdP's end-session endpoint.
      auth.signoutRedirect().catch((err) => {
        console.error('Sign-out redirect failed:', err);
      });
      return;
    }

    auth.signinRedirect(loginHint ? { extraQueryParams: { login_hint: loginHint } } : undefined).catch((err) => {
      console.error('Sign-in redirect failed:', err);
    });
    // Dialog entry: run once on mount for sign-in vs sign-out routing.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div></div>;
};
